import {
    Box,
    Card,
    CardContent,
    Skeleton,
    Stack,
    Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useGetIndividualOwnerContractorQuery } from '../../../app/Slices/SevenDayApiSlice';
import UserRole from '../../../shared/AuthRoles';
import ContractorProfile from '../../components/Contractors/Owner/ContractorProfile';

const ContractorProfilePage = () => {
    const loggedInUser = UserRole();
    const { id } = useParams();

    const { data: contractor, isFetching } =
        useGetIndividualOwnerContractorQuery(
            [loggedInUser.company, +(id as string)],
            { skip: !loggedInUser?.company || !id },
        );

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!isFetching) {
            const delay = setTimeout(() => {
                setIsLoading(false);
            }, 500); // add a 500ms delay after fetch completes

            return () => clearTimeout(delay);
        } else {
            setIsLoading(true); // reset when fetching again
        }
    }, [isFetching]);

    return (
        <Box sx={{ pb: 5 }}>
            {contractor && !isLoading ? (
                <>
                    <Typography variant='h1'>{contractor?.name}</Typography>
                    <ContractorProfile contractor={contractor} />
                </>
            ) : (
                <Stack spacing={4}>
                    <div>
                        <Skeleton height={50} width={300} />
                        <Card sx={{ mt: 2 }}>
                            <CardContent>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        gap: 2,
                                        alignItems: 'center',
                                    }}
                                >
                                    <Skeleton
                                        variant='circular'
                                        height={40}
                                        width={40}
                                    />
                                    <div>
                                        <Skeleton variant='text' width={200} />
                                        <Skeleton variant='text' width={200} />
                                    </div>
                                </Box>
                                <Skeleton
                                    variant='rounded'
                                    height={30}
                                    width='100%'
                                    sx={{ mt: 2 }}
                                />
                            </CardContent>
                        </Card>
                    </div>
                    <div>
                        <Skeleton height={30} width={200} />
                        <Skeleton height={100} />
                    </div>
                    <div>
                        <Skeleton height={30} width={200} />
                        <Skeleton height={100} />
                    </div>
                    <div>
                        <Skeleton height={30} width={200} />
                        <Skeleton height={100} />
                    </div>
                </Stack>
            )}
        </Box>
    );
};

export default ContractorProfilePage;
